/**
 * @generated SignedSource<<17e212680f937f5003544113dcfc1630>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PLUProductEditScreenQuery$variables = {
  id: string;
};
export type PLUProductEditScreenQuery$data = {
  readonly pluCategories: ReadonlyArray<{
    readonly color: string;
    readonly id: string;
    readonly title: string;
  }>;
  readonly pluProduct: {
    readonly " $fragmentSpreads": FragmentRefs<"PLUProductEditScreenProduct_PLUProduct">;
  } | null;
};
export type PLUProductEditScreenQuery = {
  response: PLUProductEditScreenQuery$data;
  variables: PLUProductEditScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "PLUCategory",
  "kind": "LinkedField",
  "name": "pluCategories",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUProductEditScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PLUProduct",
        "kind": "LinkedField",
        "name": "pluProduct",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PLUProductEditScreenProduct_PLUProduct"
          }
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PLUProductEditScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PLUProduct",
        "kind": "LinkedField",
        "name": "pluProduct",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eanCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "eanType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pluCode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PLUCategory",
            "kind": "LinkedField",
            "name": "category",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thumbhash",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ImageSize",
                "kind": "LinkedField",
                "name": "sizes",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urlExpiresAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "height",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "width",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      (v4/*: any*/)
    ]
  },
  "params": {
    "cacheID": "0e1aa5dd5f4dac8f59a4dd7d5299feb9",
    "id": null,
    "metadata": {},
    "name": "PLUProductEditScreenQuery",
    "operationKind": "query",
    "text": "query PLUProductEditScreenQuery(\n  $id: ID!\n) {\n  pluProduct(id: $id) {\n    ...PLUProductEditScreenProduct_PLUProduct\n    id\n  }\n  pluCategories {\n    id\n    color\n    title\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment PLUProductEditScreenProduct_PLUProduct on PLUProduct {\n  id\n  title\n  active\n  eanCode\n  eanType\n  pluCode\n  category {\n    id\n  }\n  image {\n    id\n    ...Image_image\n  }\n}\n"
  }
};
})();

(node as any).hash = "6089032bafe2465bb6276d3140c88a7d";

export default node;
